import { AttachmentInterface } from '../attachments/attachment.interface';
import { ItemInterface } from '../items';

export class CollectionDTO {
  constructor(
    public id: string,
    public name: string,
    public title: string,
    public visible: boolean,
    public items: ItemInterface[],
    public cover: AttachmentInterface,
    public description: string | null,
  ) {}
}
